<script setup lang='ts'>
import { useContentOperation } from '@/composables/useContentOperation'
import type { CommonType } from '~/server/types'

const props = withDefaults(defineProps<{
  dataId?: number
  dataType?: CommonType
  isShowCollect?: boolean
  isGood?: boolean
  isCollect?: boolean
}>(), {
  dataId: -1,
  dataType: 'complaint',
  isShowCollect: true,
  isGood: false,
  isCollect: false,
})

const { setFavor, setCollection } = useContentOperation()
</script>

<template>
  <div class="relative">
    <div class="flex items-center justify-center w-full overflow-hidden">
      <div class="px-3">
        <div
          class="icon-item"
          :class="{ 'is-active': props.isGood }"
          @click="setFavor(props.dataType, props.dataId, !props.isGood)"
        >
          <i class="i-bx:like text-7" />
        </div>
        <div class="text-center mt-2.5">
          点赞
        </div>
      </div>
      <div class="hidden px-3">
        <div class="icon-item">
          <i class="i-bx:like text-7 rotate" />
        </div>
        <div class="text-center mt-2.5">
          踩
        </div>
      </div>
      <div v-if="isShowCollect" class="px-3">
        <div
          class="icon-item"
          :class="{ 'is-active': props.isCollect }"
          @click="setCollection(props.dataType, props.dataId, !props.isCollect)"
        >
          <i class="i-tabler:star text-7" />
        </div>
        <div class="text-center mt-2.5">
          收藏
        </div>
      </div>
    </div>
    <UtilShare class="absolute top-0 right-0" />
  </div>
</template>

<style lang='scss' scoped>
.icon-item {
  --uno: w-13 h-13 bg-white border-1 border-solid border-gray-3 rounded-full grid place-items-center cursor-pointer;

  &.is-active {
    --uno: bg-blue-5 text-white border-none;
  }

  .rotate {
    transform: rotateZ(180deg);
  }
}
</style>
